import validate from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/nuxt/dist/pages/runtime/validate.js";
import authentication_45global from "/home/runner/work/ticketco-portal/ticketco-portal/middleware/authentication.global.ts";
import page_45title_45global from "/home/runner/work/ticketco-portal/ticketco-portal/middleware/pageTitle.global.ts";
import manifest_45route_45rule from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  authentication_45global,
  page_45title_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}